module.exports = __webpack_public_path__ + "media/images/icons/phone-e09105e4d78d7ff2d35d947ad6a7c1ad.png";